/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import httpService from '@/core/http/http.service';
import serverContextStore from '@/shared/content/server-context.store';
import { AxiosRequestConfig } from 'axios';

export class LocationClient {

    getStoreById(storeId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfStoreModel> {
        let apiPathAndParams = '/api/location/store/{storeId}';
        if (storeId === undefined || storeId === null)
            throw new Error('The parameter "storeId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{storeId}', encodeURIComponent('' + storeId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfStoreModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/location/store/{storeId}-' + cancellationContextKey : undefined);
    }
    getCitiesByPostalCode(postalCode: string | null, countryCode: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfPostalCodeWithCitiesModel> {
        let apiPathAndParams = '/api/location/postalcode/cities/{countryCode}/{postalCode}';
        if (postalCode === undefined || postalCode === null)
            throw new Error('The parameter "postalCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{postalCode}', encodeURIComponent('' + postalCode));
        if (countryCode === undefined || countryCode === null)
            throw new Error('The parameter "countryCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{countryCode}', encodeURIComponent('' + countryCode));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPostalCodeWithCitiesModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/location/postalcode/cities/{countryCode}/{postalCode}-' + cancellationContextKey : undefined);
    }
    getHubById(hubId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfHub> {
        let apiPathAndParams = '/api/location/hub/{hubId}';
        if (hubId === undefined || hubId === null)
            throw new Error('The parameter "hubId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{hubId}', encodeURIComponent('' + hubId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfHub>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/location/hub/{hubId}-' + cancellationContextKey : undefined);
    }
    getCountries(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfCountryModelOf> {
        let apiPathAndParams = '/api/location/country';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfCountryModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/location/country-' + cancellationContextKey : undefined);
    }
    getCallingCodes(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfCallingCodeModelOf> {
        let apiPathAndParams = '/api/location/country/calling-codes';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfCallingCodeModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/location/country/calling-codes-' + cancellationContextKey : undefined);
    }
}

export const LocationClientService = new LocationClient();

export interface ClientResponseOfStoreModel {
    model: StoreModel | undefined;
    messages: ClientMessage[];
}

export interface StoreModel {
    id: string;
    name: string;
    street: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    openingHours: OpeningHours[];
    imageUrl: string;
    salesManager: EmployeeModel | undefined;
}

export interface OpeningHours {
    startTime: Date;
    endTime: Date;
    isClosed: boolean;
    shortFormattedDay: string;
    formattedDay: string;
    formattedDate: string;
    formattedTime: string;
}

export interface EmployeeModel {
    id: string;
    name: string;
}

export interface ClientMessage {
    labelKey: string | undefined;
    message: string;
    messageType: ClientMessageType;
}

export enum ClientMessageType {
    Error = 0,
    Warning = 1,
    Info = 2,
}

export interface ClientResponse {
    messages: ClientMessage[];
}

export interface ClientResponseOfPostalCodeWithCitiesModel {
    model: PostalCodeWithCitiesModel | undefined;
    messages: ClientMessage[];
}

export interface PostalCodeWithCitiesModel {
    postalCode: string;
    cities: string[];
    isUnknown: boolean;
}

export interface ClientResponseOfHub {
    model: Hub | undefined;
    messages: ClientMessage[];
}

export interface Hub {
    id: string;
    name: string;
    address: string;
    street: string;
    city: string;
    zipCode: string;
    county: string;
    state: string;
    countryRegionId: string;
    latitude: number;
    longitude: number;
    type: HubType;
    openingHours: OpeningHours[];
    nextDaysOpeningHours: OpeningHours[];
    generalOpeningHours: GeneralOpeningHours[];
    notes: string;
    purpose: string;
    defaultNumberOfDaysForOpeningHours: number;
    isPickUpPoint: boolean;
}

export enum HubType {
    Standard = 0,
    Partner = 2,
}

export interface GeneralOpeningHours {
    dayOfWeek: DayOfWeek;
    isOpen: boolean;
    openTime: string;
    closeTime: string;
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export interface ClientResponseOfCountryModelOf {
    model: CountryModel[] | undefined;
    messages: ClientMessage[];
}

export interface CountryModel {
    code: string;
    name: string;
    localizedNames: { [key: string]: string; };
    deliveryType: CountryDeliveryType;
    freeDeliveryAmount: number;
    targetCountryCode: string;
    deliveryToTargetCountry: boolean;
    callingCodes: string[];
    isShadowCountry: boolean;
}

export enum CountryDeliveryType {
    Undefined = "Undefined",
    Wws = "Wws",
    None = "None",
    Own = "Own",
    ShadowCountry = "ShadowCountry",
}

export interface ClientResponseOfCallingCodeModelOf {
    model: CallingCodeModel[] | undefined;
    messages: ClientMessage[];
}

export interface CallingCodeModel {
    code: string;
    language: string;
    countryCodes: string[];
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}